import { FlexLayout, Icon } from '@deity/falcon-ui';
import { Input, MenuItem, Select } from '@deity-io/portal-ui';
import { SchemaActionTypes, SchemaContext } from 'contexts/SchemaContext';
import type { FC } from 'react';
import { useContext } from 'react';

interface FieldTypeEditorProps {
  type: string | { type: string };
  availableTypes: string[];
  fieldPath: string[];
  isEditable: boolean;
}
const FieldTypeEditor: FC<FieldTypeEditorProps> = ({ isEditable, type, availableTypes, fieldPath }) => {
  const ctx = useContext(SchemaContext);
  const onSelect = (selectedType: string) => {
    ctx?.dispatch({ type: SchemaActionTypes.UPDATE_TYPE, payload: { type: selectedType, fieldPath } });
  };

  const types = availableTypes.map(t => ({ value: t, label: t }));

  const typeString = typeof type === 'string' ? type : Object.keys(type).find(() => true) || '';

  return (
    <FlexLayout width="full" flexDirection="column" mt="sm">
      <Select
        label="Type"
        sx={{ marginY: 1 }}
        onChange={(t: any) => onSelect(t.value)}
        options={types}
        value={{ value: typeString, label: typeString }}
        disabled={!isEditable}
        renderOption={(props, option) => (
          <MenuItem {...props}>
            <Icon
              fill="badgeText"
              stroke="transparent"
              src={option.label}
              fallback="dict"
              css={{ width: 18 }}
              mr="xs"
            />
            {option.label}
          </MenuItem>
        )}
        renderInput={p => (
          <Input
            {...p}
            label="Type"
            InputProps={{
              ...p.InputProps,
              startAdornment: (
                <>
                  <Icon fill="badgeText" stroke="transparent" src={typeString} fallback="dict" css={{ width: 18 }} />
                  {p.InputProps.startAdornment}
                </>
              )
            }}
          />
        )}
        autoComplete
        disableClearable
      />
    </FlexLayout>
  );
};

export default FieldTypeEditor;
